import { fetchDataDocs, fetchDetails } from "../../services/sharedViews.service";
import { actionTypes } from "../contants/actionTypes";
import { ensureArray, ensureJsonObject } from "../../utils/validateResponseApi";
import { callApi } from "../../services/api.service";
import { mergeArrays } from "../../utils/arrayUtils";

//#region LOAD_ALL_DOCS
const getData = async (accessToken, variables, id_user_action) => {
    const response = await fetchDataDocs(accessToken, variables, id_user_action);
    return response.data;
}

export const getAllDocs = (accessToken, id_user_action, filters, pagination, append = false) => {
    return async (dispatch, getState) => {
        if (!append) dispatch(setIsLoading(true));
        dispatch(LoadData(actionTypes.filterAndPagination, { filters, pagination }));
        try {
            const docsData = await getData(accessToken, { filters, pagination, mode: 'SELECT' }, id_user_action);
            let mergedDocs = ensureArray(docsData) || [];
            if (append) {
                const currentDocs = getState().sharedViews.listAllDocs;
                mergedDocs = mergeArrays(currentDocs, mergedDocs);
            }
            dispatch(loadAllDocs(mergedDocs));
            try {
                const counterData = await getData(accessToken, { filters, pagination, mode: 'COUNTER' }, id_user_action);
                dispatch(LoadData(actionTypes.counter, counterData?.[0]?.count ?? mergedDocs.length));
            } catch (e) {
                dispatch(LoadData(actionTypes.counter, mergedDocs.length));
            }

        } catch (e) {
            console.error("ERROR getAllDocs", e);
            dispatch(loadAllDocs([]));
            dispatch(LoadData(actionTypes.counter, 0));
        } finally {
            dispatch(setIsLoading(false));
        }
    };
};


export const loadAllDocs = (data) => ({
    type: actionTypes.loadAllDocs,
    payload: data
});

const setIsLoading = (data) => ({
    type: actionTypes.isLoadingLoadAllDocs,
    payload: data
});
//#endregion

//#region SHARED DETAILS TABLE
export const getColumns = (accessToken, id) => {
    return (dispatch) => {
        callApi("user_select", "MENU_ID", { id_user_action: id }, accessToken)
            .then(({ data }) => {
                const config = ensureJsonObject(data?.[0]?.configuration);
                const table = ensureArray(config.table);
                const button = ensureArray(config.button);

                dispatch(loadConfiguration(button));
                dispatch(loadColumsTable(table));
            }).catch((e) => {
                console.error('ERROR getColumns', e);
            }).finally(() => {
            });
    }
};

export const getDetails = (accessToken, id, variables) => {
    return (dispatch) => {
        dispatch(setIsLoadingDetails(true));
        fetchDetails(accessToken, id, variables)
            .then(({ data }) => {
                dispatch(LoadData(actionTypes.getListDetails, data ?? []));
            }).catch((e) => {
                console.log('error', e)
            }).finally(() => {
                dispatch(setIsLoadingDetails(false));
            });
    }
};

export const LoadData = (action, data) => ({
    type: action,
    payload: data
});

export const loadColumsTable = (data) => ({
    type: actionTypes.getColumnsTableDetails,
    payload: data
});

export const loadConfiguration = (data) => ({
    type: actionTypes.getConfigurationTableDetails,
    payload: data
});

const setIsLoadingDetails = (data) => ({
    type: actionTypes.isLoadingListDetails,
    payload: data
});
//#endregion